function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 233.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "aaa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.33,20.83c0,5.56-8.33,5.56-8.33,0s8.33-5.55,8.33,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.67,20.83c0,5.56-8.34,5.56-8.34,0s8.34-5.55,8.34,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,20.83c0,5.56-8.33,5.56-8.33,0s8.33-5.55,8.33,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.83,41.67H4.17c-5.56,0-5.56-8.34,0-8.34H245.83C251.39,33.33,251.39,41.67,245.83,41.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.5,216.67H204.17c-5.56,0-5.56-8.34,0-8.34H237.5a4.17,4.17,0,0,0,4.17-4.16V12.5a4.17,4.17,0,0,0-4.17-4.17H12.5A4.17,4.17,0,0,0,8.33,12.5V204.17a4.17,4.17,0,0,0,4.17,4.16H45.83c5.56,0,5.56,8.34,0,8.34H12.5A12.5,12.5,0,0,1,0,204.17V12.5A12.5,12.5,0,0,1,12.5,0h225A12.5,12.5,0,0,1,250,12.5V204.17A12.5,12.5,0,0,1,237.5,216.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.21,233.68a3.87,3.87,0,0,1-1.87-.44L125,206.81,71.66,233.24a4.18,4.18,0,0,1-6-4.33L74.34,170,32.68,127.43a4.16,4.16,0,0,1,2.3-7l58.73-10,7.46-14.29a4.18,4.18,0,0,1,7.42,3.87l-8.46,16.14a4.16,4.16,0,0,1-3,2.17l-52.91,9,37.55,38.37a4.06,4.06,0,0,1,1.13,3.52l-7.81,53.08,48.09-23.84a4.33,4.33,0,0,1,3.69,0L175,222.27l-7.82-53.08a4.15,4.15,0,0,1,1.14-3.52l37.53-38.37-52.9-9a4.16,4.16,0,0,1-3-2.17L125,68.58l-6.08,11.59c-2.55,4.94-10,1.07-7.38-3.87l9.77-18.66a4.34,4.34,0,0,1,7.38,0l27.6,52.78,58.73,10a4.18,4.18,0,0,1,2.3,7L175.66,170l8.67,58.9A4.19,4.19,0,0,1,180.21,233.68Z",
    style: {
      fill: "#263238"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.3dce9654edaf647f6276fd20b582219a.svg";
export { ForwardRef as ReactComponent };